'use strict';

module.exports = {
    createCarousel: function () {
        const experienceSlides = $('.slick-carousel-wrapper .experience-slides');
        const carouselWrapper = $('.slick-carousel-wrapper');
        for (let index = 0; index < experienceSlides.length; index++) {
            $(experienceSlides[index]).slick($(carouselWrapper[index]).data('slick'));
        }
    }
};
